export default "__VITE_ASSET__Ctlg17tM__"